module.exports = __webpack_public_path__ + "static/media/glamet.bdd7d613.pdf";